module.exports = __webpack_public_path__ + "static/media/eulerity.ec38b91a.pdf";